/** Keep email sending and attachement handling hooks */
export default {
    data: function () {
        return {
            newMessage: '',
            attachements: [],
            attachementDialog: false,
            uploadingAttachement: false,
        }
    },
    methods: {
        sendEmail (toEmails, body, parentThreadId=null) {
            const vm = this
            // Add attachements html before sending
            if (vm.attachements.length) {
                body += `<hr style="width: 100%"></hr>`
                vm.attachements.forEach(attachement => {
                    body += attachement.html
                });
            }

            Vue.backendApi()
                .sendEmailMessage({
                    to_emails: toEmails,
                    subject: '',
                    body: body,
                    parent_thread_id: parentThreadId
                })
                .then(onSuccess, onError);

            function onSuccess(response) {
                vm.messageAreLoading = false;
                if (vm.contactsToForward.length) {
                    vm.$swal({
                        type: 'success',
                        title: 'Message forwarded',
                        text: 'Message successfully forwarded',
                    });
                    vm.contactsToForward = []
                } else {
                    vm.$swal({
                        type: 'success',
                        title: 'Message sent',
                        text: 'Message successfully sent',
                    });
                }
                vm.attachements = []
                vm.newMessage = []
                return true;
            }

            function onError(err) {
                vm.messageAreLoading = false;
                vm.attachements = []
                if (vm.contactsToForward.length) {
                    vm.$swal({
                        type: 'error',
                        title: 'Message forwarding failed',
                        text: 'Unable to forward message',
                    });
                    vm.contactsToForward = []
                } else {
                    vm.$swal({
                        type: 'error',
                        title: 'We were unable to send your email',
                        text: err,
                    });
                }
            }
        },
        handleAttachementUpload (event) {
            const vm = this;
            const fileSelected = event.target.files.length > 0;
            if (!fileSelected) {
                return;
            }
            vm.uploadingAttachement = true
            let filename = event.target.files[0].name
            function onSuccess(response) {
                let trimmedFilename = filename.substring(0, 20);
                if (filename.length > trimmedFilename.length) {
                    trimmedFilename += '...'
                }
                let displayName = `${response.data.mimetype} - ${vm.formatBytes(response.data.size)} - ${trimmedFilename}`
                let attachementHtml = `  <a
                                        id="attachement"
                                        href="${response.data.url}"
                                        target="_blank"
                                        style="
                                            color: #3f51b5;
                                            font-size: 12px;
                                            border: 2px solid #3f51b5;
                                            padding: 4px;
                                            padding-left: 10px;
                                            padding-left: 10px;
                                            border-radius: 8px;
                                        "
                                    >${displayName}</a>`
                vm.attachements.push({
                    name: displayName,
                    html: attachementHtml
                })
                vm.uploadingAttachement = false
                return true;
            }
            function onError(err) {
                // eslint-disable-next-line no-console
                vm.uploadingAttachement = false
                vm.attachementDialog = false
                console.trace('Error: ', err);
            }
            Vue.backendApi()
                .uploadAttachement(event.target.files[0])
                .then(onSuccess, onError);
        },
        /** Convert bytes to either Kb, Mb, Gb or Tb */
        formatBytes (bytes) {
            let sizes = ['bytes', 'Kb', 'Mb', 'Gb', 'Tb'];
            if (bytes == 0) return '0 Byte';
            let i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
            return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
        },
        removeAttachement (index) {
            this.attachements.splice(index, 1);
            // Todo: Call Api to delete remote attachement file  
        }
    },
};
